import React from "react";
import '../styles/components.css';

const TravelCardImage = ({ snap, title, description }) => {
    return (
        <article className="travel_card_articles">
            <aside>
                <img src={snap} alt="travel_card_snaps" loading='lazy' />
            </aside>
            <h4>{title}</h4>
            <p>{description}</p>
        </article>
    );
};

export default TravelCardImage;